export default {
  title: "Pipeline",
  activeDrivers_one: "{{count}} faol driver",
  activeDrivers_other: "{{count}} faol driver",
  loadFailed: "Pipeline'ni yuklab bo'lmadi.",
  conflictTitle: "Boshqa foydalanuvchi o'zgartirdi",
  conflictDesc: "{{who}} hozirgina {{name}} ni yangiladi. Doska yangilandi.",
  conflictDescAnon: "Kimdir {{name}} ni yangiladi. Doska yangilandi.",
  network: "Serverga ulanib bo'lmadi. Internetni tekshiring.",
  scope: { my: "Mening driverlarim", myBranch: "Mening filialim", branch: "Filial #{{id}}", all: "Barcha filiallar" },
  noDrivers: "Driver yo'q",
  more: "+{{n}} ta yana · filtr ishlating",
  rejectZone: "Rad etish uchun shu yerga tashlang · sabab majburiy",
  rejectZoneOptional: "Rad etish uchun shu yerga tashlang",
  hired: "Hired · {{n}} →",
  filters: {
    recruiter: "Recruiter",
    allRecruiters: "Barcha recruiterlar",
    job: "Carrier / vakansiya",
    allCarriers: "Barcha carrierlar",
    source: "Manba",
    search: "Ism yoki telefon bo'yicha filtr",
  },
  card: {
    overdue: "{{label}} · kechikdi",
    next: "Keyingi: {{label}} · {{when}}",
    firstCall: "Keyingi: Birinchi qo'ng'iroq",
    collectDocs: "Keyingi: Hujjatlarni yig'ish",
    waitCarrier: "Carrier kutilmoqda",
    waitBg: "Background check kutilmoqda",
    confirmOrientation: "Orientation sanasini tasdiqlash",
    cdlExp: "CDL muddati {{date}}",
    cdlNone: "CDL muddati —",
    daysInStage: "Bu bosqichda {{n}} kun",
    days: "{{n}}k",
    unassigned: "Biriktirilmagan",
  },
  move: {
    title: "{{status}} ga o'tkazish",
    which: "{{name}} · qaysi vakansiya?",
    markHired: "Hired deb belgilash",
    submit: "Yuborish",
    noJobs: "Ochiq vakansiya yo'q. Menejerdan Jobs bo'limida qo'shishni so'rang.",
    onlyOpen: "Faqat ochiq vakansiyalar ko'rsatiladi.",
    startDate: "Boshlash sanasi",
    evidence: "Dalil / izoh",
    note: "Yuborish izohi",
    hiredHint: "Hired menejer tasdig'idan keyin hisoblanadi (Approvals).",
    placeholderHired: "Carrier email orqali tasdiqladi…",
    placeholderNote: "Toza MVR, 2 yil dry van",
  },
  reject: {
    title: "{{name}} ni rad etish",
    titlePlain: "Rad etish",
    desc: "Driver pipeline'dan chiqadi. Sabab majburiy va holat tarixiga yoziladi.",
    rejectDriver: "Driverni rad etish",
    notInterested: "Qiziqmagan deb belgilash",
    rejectedOpt: "Rad etildi (carrier yoki biz)",
    notInterestedOpt: "Qiziqmagan",
    reason: "Sabab",
    chooseReason: "Sababni tanlang…",
    note: "Izoh",
    notePlaceholder: "Tarix uchun ixtiyoriy tafsilotlar",
  },
};
